<template>
    <v-container class="pa-5" fluid>
        <MapDialog
            :is-open="mapDialog"
            :localization-data="team"
            :google="google"
            :height="windowHeight"
            @on-save="saveCoordinates"
            @on-close="closeMapDialog"
        />

        <page-title>
            Ekipa
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" lg="7" class="d-flex">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Dane ekipy</v-toolbar-title>
                                            </v-toolbar>
                                            <v-divider />
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                v-model="team.name"
                                                                label="Nazwa"
                                                                outlined
                                                                dense
                                                                :error-messages="nameErrors"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                :value="team.contactPerson"
                                                                label="Osoba do kontaktu"
                                                                outlined
                                                                dense
                                                                @input="changeContactPerson"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-model="team.contactMail"
                                                                label="E-mail"
                                                                outlined
                                                                dense
                                                                :error-messages="contactMailErrors"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-model="team.phoneNumber"
                                                                label="Nr telefonu"
                                                                outlined
                                                                :error-messages="phoneNumberErrors"
                                                                dense
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                :value="team.street"
                                                                label="Ulica"
                                                                outlined
                                                                dense
                                                                @input="changeStreet"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                :value="team.postCode"
                                                                label="Kod pocztowy"
                                                                outlined
                                                                dense
                                                                @input="changePostCode"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                :value="team.city"
                                                                label="Miasto"
                                                                outlined
                                                                dense
                                                                @input="changeCity"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-mask="'##.######'"
                                                                :value="team.latitude"
                                                                label="Szerokość geograficzna"
                                                                outlined
                                                                dense
                                                                @input="changeLocalizationLatitude"
                                                                @change="saveCoordinates(team.latitude, team.longitude)"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-mask="'##.######'"
                                                                :value="team.longitude"
                                                                label="Długość geograficzna"
                                                                outlined
                                                                dense
                                                                @input="changeLocalizationLongitude"
                                                                @change="saveCoordinates(team.latitude, team.longitude)"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col v-if="isFromOutdoorsTeams" cols="12">
                                                            <v-autocomplete
                                                                v-model="team.contractorId"
                                                                :items="contractors"
                                                                label="Zleceniobiorca"
                                                                dense
                                                                hide-details
                                                                outlined
                                                                item-value="id"
                                                                item-text="name"
                                                                no-data-text="Nie znaleziono"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                        <v-col cols="12" lg="5" class="d-flex">
                            <v-container class="d-flex pa-0">
                                <v-row>
                                    <v-col cols="12" class="d-flex">
                                        <v-card ref="mapPreview" min-height="450" class="flex-grow-1">
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Podgląd lokalizacji</v-toolbar-title>
                                                <v-spacer />
                                                <v-btn
                                                    color="primary"
                                                    outlined
                                                    data-sentry-label="Wskaż"
                                                    @click="showMapDialog"
                                                >
                                                    <v-icon left dark>
                                                        mdi-map-marker
                                                    </v-icon>
                                                    Wskaż
                                                </v-btn>
                                            </v-toolbar>

                                            <v-divider />

                                            <MapPreview
                                                :api-key="apiKey"
                                                :latitude="savedLatitude"
                                                :longitude="savedLongitude"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="success"
                                medium
                                data-sentry-label="Zapisz"
                                :loading="actionLoading"
                                @click="saveTeam"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import { googleMapsApiLoader } from '@/utils/googleMapsApiLoader'
import { mask } from 'vue-the-mask'

import PageTitle from '@/components/common/PageTitle'
import MapDialog from '@/views/Outdoors/Common/MapDialog'
import MapPreview from '@/views/Outdoors/Common/MapPreview'

import { required, email, numeric } from 'vuelidate/lib/validators'

import { errorHandler } from '@/utils/errorHandler'

import parse from '@/mixins/parse'

import { appConfig } from '@/config'

export default {
    name: 'OutdoorsTeam',
    directives: { mask },
    components: {
        PageTitle,
        MapPreview,
        MapDialog
    },
    mixins: [ parse ],
    beforeRouteEnter(to, from, next) {
        if (typeof to.params.id !== 'undefined') {
            Promise.all([
                store.dispatch('outdoors/outdoorsSettings/getContractors'),
                store.dispatch('outdoors/outdoorsSettings/getTeam', to.params.id)
            ])
                .then(responses => {
                    next(vm => {
                        vm.action = 'updateTeam'
                        vm.contractors = responses[0].data.results
                        responses[1].data.name ? vm.pageTitle = `Ekipa - ${responses[1].data.name}` : vm.pageTitle = 'Ekipa'
                        vm.team = Object.assign({}, responses[1].data)
                        vm.savedLatitude = responses[1].data.latitude
                        vm.savedLongitude = responses[1].data.longitude

                        if (typeof to.params.isFromOutdoorsTeams !== 'undefined') {
                            vm.isFromOutdoorsTeams = to.params.isFromOutdoorsTeams
                        }

                        if (from.name !== null) {
                            vm.originRoute = {
                                name: from.name,
                                params: from.params
                            }
                        }
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        } else {
            next(vm => {
                vm.action = 'createTeam'
                vm.pageTitle = 'Nowa ekipa'

                if (typeof to.params.isFromOutdoorsTeams !== 'undefined') {
                    vm.isFromOutdoorsTeams = to.params.isFromOutdoorsTeams

                    if (!vm.isFromOutdoorsTeams) {
                        vm.team.contractorId = from.params.id
                    }
                }

                if (from.name !== null) {
                    vm.originRoute = {
                        name: from.name,
                        params: from.params
                    }
                }
            })
        }
    },
    data() {
        return {
            team: {
                name: null,
                contactPerson: null,
                city: null,
                street: null,
                postCode: null,
                contactMail: null,
                phoneNumber: null,
                contractorId: null,
                latitude: null,
                longitude: null
            },
            google: null,
            mapDialog: false,
            savedLatitude: null,
            savedLongitude: null,
            contractors: [],
            actionLoading: false,
            apiKey:  appConfig.outdoors.map.apiKey,
            isFromOutdoorsTeams: true,
            originRoute: {
                name: 'outdoorsSettingsOutdoorsTeams'
            },
            windowHeight: 0
        }
    },
    computed: {
        nameErrors() {
            const errors = []

            if (!this.$v.team.name.$dirty) return errors
            if (!this.$v.team.name.required)
                errors.push('Nazwa jest wymagana.')

            return errors
        },
        contactMailErrors() {
            const errors = []

            if (!this.$v.team.contactMail.$dirty) return errors

            if (!this.$v.team.contactMail.email)
                errors.push('Proszę podać poprawny format dla adresu email.')

            return errors
        },
        phoneNumberErrors() {
            const errors = []

            if (!this.$v.team.phoneNumber.$dirty) return errors
            if (!this.$v.team.phoneNumber.numeric)
                errors.push('Proszę podać poprawny format dla numeru telefonu.')

            return errors
        }
    },
    validations: {
        team: {
            name: {
                required
            },
            contactMail: {
                email
            },
            phoneNumber: {
                numeric
            }
        }
    },
    methods: {
        changeContactPerson(value) {
            this.team.contactPerson = this.parseEmptyStringToNull(value)
        },
        changeStreet(value) {
            this.team.street = this.parseEmptyStringToNull(value)
        },
        changePostCode(value) {
            this.team.postCode = this.parseEmptyStringToNull(value)
        },
        changeCity(value) {
            this.team.city = this.parseEmptyStringToNull(value)
        },
        changeLocalizationLatitude(value) {
            const parsedValue = this.parseEmptyStringToNull(value)

            this.team.latitude = parsedValue ? parseFloat(parsedValue) : null
        },
        changeLocalizationLongitude(value) {
            const parsedValue = this.parseEmptyStringToNull(value)

            this.team.longitude = parsedValue ? parseFloat(parsedValue) : null
        },
        showMapDialog() {
            this.windowHeight = window.innerHeight - 250

            googleMapsApiLoader({
                apiKey: appConfig.outdoors.map.apiKey,
                language: 'pl',
                region: 'PL',
                mapId: appConfig.outdoors.map.mapId
            })
                .then(google => {
                    this.google = google
                    this.mapDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeMapDialog() {
            this.mapDialog = false
            this.google = null
        },
        saveCoordinates(latitude, longitude) {
            if (latitude && longitude) {
                this.team.latitude = latitude
                this.team.longitude = longitude
                this.savedLatitude = latitude
                this.savedLongitude = longitude
            }
        },
        saveTeam() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$store.dispatch(`outdoors/outdoorsSettings/${this.action}`, this.team)
                .then(() => {
                    this.$router.push(this.originRoute)
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        onClose() {
            this.$router.push(this.originRoute)
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>